import React from "react";
import GA4Event from "@analytics/GoogleAnalytics/GA4Event";
import * as GA4Service from "@analytics/GoogleAnalytics/GA4Service";
import LifeAtButton from "@common/LifeAtButton/LifeAtButton";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import DarkModeMoonIcon from "@icons/MoonIcon-DarkMode.svg";
import LightModeSunIcon from "@icons/SunIcon-LightMode.svg";
import { updateLightModeSetting } from "@user/service/UserSettingsService";

const SWITCH_AUDIO: any = document.getElementById("switchAudio");
const SWITCH_AUDIO_VOL = 0.3;
if (SWITCH_AUDIO) {
    SWITCH_AUDIO.volume = SWITCH_AUDIO_VOL;
}

export default function LightDarkModeButton() {
    const { lightMode, setLightMode }: AppearanceContextType = useAppearanceContext();
    const { user }: UserContextType = useUserContext();

    const buttonIcon = lightMode ? <LightModeSunIcon /> : <DarkModeMoonIcon />;

    const handleClick = () => {
        SWITCH_AUDIO.play();

        if (lightMode) {
            // Action is to switch to Dark Mode
            GA4Service.logEvent(GA4Event.ENABLE_DARK_MODE);
        } else {
            // Action is to switch to light mode
            GA4Service.logEvent(GA4Event.ENABLE_LIGHT_MODE);
        }

        updateLightModeSetting(!lightMode, user);
        setLightMode(!lightMode);
    };

    return <LifeAtButton icon={buttonIcon} isLink={false} handleClick={handleClick} />;
}
